import * as React from 'react'

import { SensorIcon } from '~/client/src/shared/components/icons/SensorIcon'

import { MapMarkerProps } from './MapMarker'

const StruxTagMapMarker: React.FC<MapMarkerProps> = ({ title, onClick }) => (
  <div
    className="tw:relative tw:block tw:w-8 tw:h-[38px] tw:cursor-pointer"
    title={title}
    onClick={onClick}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="38"
      viewBox="0 0 32 38"
      fill="none"
      className="tw:absolute tw:inset-0"
      aria-hidden="true"
    >
      <path
        d="M4.5 0.5H27.5C29.7091 0.5 31.5 2.29086 31.5 4.5V27.5C31.5 29.7091 29.7091 31.5 27.5 31.5H22L16 37.5L10 31.5H4.5C2.29086 31.5 0.5 29.7091 0.5 27.5V4.5C0.5 2.29086 2.29086 0.5 4.5 0.5Z"
        fill="#2E3133"
        stroke="#FFFFFF"
      />
    </svg>
    <SensorIcon
      size="md"
      className="tw:absolute tw:left-1 tw:top-1 tw:text-white"
    />
  </div>
)

export default StruxTagMapMarker
